import { render, staticRenderFns } from "./Referrers.vue?vue&type=template&id=65f91c08&scoped=true&"
import script from "./Referrers.vue?vue&type=script&lang=js&"
export * from "./Referrers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f91c08",
  null
  
)

export default component.exports